import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-machine-category-media-list",
  templateUrl: "./machine-category-media-list.component.html",
  styleUrls: ["./machine-category-media-list.component.scss"],
})
export class MachineCategoryMediaListComponent implements OnInit {
  @Input() categories: { label: string; subLabel: string; value: string }[] = [];
  @Input() makes: any[] = [];
  @Input() location: any;
  @Input() twoColumns: boolean = false;

  @Input() visibleLimit: number = 8;
  isExpanded: boolean;

  constructor() {}

  ngOnInit(): void {}

  clearOutMakes(): void {
    this.makes = [];
  }

  onToggle(event: Event): void {
    this.isExpanded = (event.target as HTMLDetailsElement).open;
  }
}
